"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconRemaintNuclearOutageConcept = function IconRemaintNuclearOutageConcept(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M33.156 24.19 24.03 8.38l-9.126 15.81L5.767 40h36.526zm-9.127-11.81 7.395 12.81L38.827 38H9.232l7.404-12.81zm.091 10.18c-.848 0-1.42 1.315-1.69 3.296-1.852-.757-3.279-.92-3.703-.185s.432 1.892 2.017 3.119c-1.584 1.227-2.44 2.383-2.016 3.118s1.85.572 3.701-.184c.27 1.98.843 3.296 1.691 3.296s1.422-1.32 1.692-3.305c1.854.759 3.281.921 3.706.186.424-.734-.429-1.887-2.008-3.111 1.58-1.224 2.433-2.378 2.009-3.112-.425-.735-1.853-.572-3.707.186-.27-1.985-.843-3.304-1.692-3.304m-.864 5.736a21 21 0 0 1 .873-.504 21 21 0 0 1 .855.494 21 21 0 0 1 0 1.008l-.191.115-.235.137q-.215.125-.43.242a20 20 0 0 1-.872-.504l-.004-.222-.002-.272q0-.25.006-.494m-1.654 1.117c-1.3.97-2.108 1.82-2.008 1.995.1.173 1.237-.1 2.724-.738q-.03-.398-.047-.818a23 23 0 0 1-.669-.44m5.05-1.246q-.328-.225-.683-.45-.017-.41-.047-.798c1.491-.641 2.63-.915 2.73-.741.101.173-.703 1.02-2 1.989m-1.808-1.871c-.19-1.612-.523-2.736-.724-2.736s-.532 1.12-.723 2.727q.36.173.732.368.363-.19.715-.36m-2.573 1.432q.017-.42.047-.818c-1.488-.64-2.625-.912-2.725-.739s.708 1.025 2.01 1.996q.32-.22.668-.44m3.698 2.135q.355-.225.684-.45c1.295.968 2.099 1.815 1.999 1.988s-1.24-.1-2.73-.74q.03-.388.047-.798m-2.572 1.43q.36-.173.732-.368.363.19.715.359c-.19 1.612-.523 2.736-.724 2.736s-.532-1.12-.723-2.727",
    clipRule: "evenodd"
  })));
};

export { IconRemaintNuclearOutageConcept, IconRemaintNuclearOutageConcept as default };
